export enum RecommendationContext {
  EvaluationInformation = 'EvaluationInformation',
  FocusAreas = 'FocusAreas',
  KeyFindings = 'KeyFindings',
  SectionIntroduction = 'SectionIntroduction',
  DividerPageSummary = 'DividerPageSummary',
  CommitteesStructureSummary = 'CommitteesStructureSummary',
}
